import { Map } from "immutable";

import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import QuestionAggregation from "../../../../../../models/QuestionsAggregation/QuestionAggregation";
import * as questionAggregateSelectors from "./question";

type State = Map<string, QuestionAggregation>;

export function getQuestion(state: State, questionId: string) {
  return state.get(questionId);
}

export const { getAverageMark, getMarksTotal } = composeSelectors(
  getQuestion as any,
  questionAggregateSelectors
);
